// // /src/pages/components/stats-cards/StatsCard.js
// import React from "react";
// import "./StatsCard.css";

// export default function StatsCard({ data = [] }) {
//   if (!data || data.length === 0) return null;

//   const [main, ...rest] = data;

//   return (
//     <div className="metric-card">
//       <div className="metric-card__content">
//         {/* LEFT: ICON + MAIN VALUE */}
//         <div className="metric-card__main">
//           {main.icon && (
//             <div className="metric-card__icon">
//               <svg
//                 width="24"
//                 height="24"
//                 viewBox="0 0 24 24"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 {main.icon}
//               </svg>
//             </div>
//           )}

//           <div className="metric-card__value">{main.statsInfo}</div>
//           <div className="metric-card__label">{main.title}</div>
//         </div>

//         {/* RIGHT: CORK / LIMERICK (no icons here, sirf numbers) */}
//         {rest.length > 0 && (
//           <div className="metric-card__split" style={{alignItems:"center"}}>
//             {rest.map((item, idx) => (
//               <div key={idx} className="metric-card__split-item" style={{textAlign:"center"}}>
//                 <div className="metric-card__split-label">{item.title}</div>
//                 <div className="metric-card__split-value" >
//                   {item.statsInfo}
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }



















// /src/pages/components/stats-cards/StatsCard.js
import React from "react";
import "./StatsCard.css";

export default function StatsCard({ data = [] }) {
  if (!data || data.length === 0) return null;

  const [main, ...rest] = data;

  return (
    <div className="metric-card">
      <div className="metric-card__content">
        {/* LEFT */}
        <div className="metric-card__main">
          {main.icon && (
            <div className="metric-card__icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                color=""
              >
                {main.icon}
              </svg>
            </div>
          )}

          <div className="metric-card__value">{main.statsInfo}</div>
          <div className="metric-card__label">{main.title}</div>
        </div>

        {/* RIGHT */}
        {/* {rest.length > 0 && (
          <div className="metric-card__split">
            {rest.map((item, idx) => (
              <div key={idx} className="metric-card__split-item">
                <div className="metric-card__split-label">{item.title}</div>
                <div className="metric-card__split-value">{item.statsInfo}</div>
              </div>
            ))}
          </div>
        )} */}
      </div>
    </div>
  );
}


